import { createContext } from "react";

const medicalContext = createContext();

export default medicalContext;
